export default __webpack_public_path__ + "assets/img/icon-modify-off.9557f189edcaf1b7185ecec3449ceda2.svg";